import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './styles/index.css';
import Table from "./containers/Table";

const render = () => {
    return ReactDOM.render(
            <Provider store={store}>
                <Table/>
            </Provider>,
        document.getElementById('table')
    );
};

render();

if (module.hot) {
    module.hot.accept('./containers/Table', () => { render() })
}
